import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { EnvironmentOptionStore } from '../stores';

export function provideEnvironmentOptions(): EnvironmentProviders {
  return makeEnvironmentProviders([
    EnvironmentOptionStore,

    provideAppInitializer(() => {
      const store = inject(EnvironmentOptionStore);
      return store.load();
    }),
  ]);
}
